var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocuments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 218,
    height: 250,
    viewBox: "0 0 218 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 17 128 L 17 246 109 246 L 201 246 201 160.244 L 201 74.488 168.744 42.244 L 136.489 10 76.744 10 L 17 10 17 128 M 27.531 20.802 C 27.239 21.094, 27 69.408, 27 128.167 L 27 235 109 235 L 191 235 191 158.500 L 191 82 160 82 L 129 82 129 51.136 L 129 20.271 78.531 20.271 C 50.773 20.271, 27.823 20.510, 27.531 20.802 M 140 49.833 L 140 72 161.699 72 L 183.398 72 161.956 50.250 C 150.163 38.288, 140.399 28.313, 140.257 28.083 C 140.116 27.854, 140 37.642, 140 49.833 M 58 118 L 58 123 109 123 L 160 123 160 118 L 160 113 109 113 L 58 113 58 118 M 58 148.250 L 58 153.500 99 153.500 L 140 153.500 140 148.250 L 140 143 99 143 L 58 143 58 148.250 M 58 179 L 58 184 109 184 L 160 184 160 179 L 160 174 109 174 L 58 174 58 179",
    stroke: "none",
    fill: "#4c39a0",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocuments);
export default __webpack_public_path__ + "static/media/documents.e3bab4c5f99ab28e868b0fc3e8684d10.svg";
export { ForwardRef as ReactComponent };